"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayButton = void 0;
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
function PlayButton({ progress, size, ...rest }) {
    function getSize() {
        switch (size) {
            case 'small':
                return { width: 60, height: 60 };
            case 'medium':
                return { width: 120, height: 120 };
            case 'large':
                return { width: 180, height: 180 };
            default:
                return { width: 0, height: 0 };
        }
    }
    return (react_1.default.createElement("div", { style: {
            height: `${getSize().height}px`,
            aspectRatio: 1,
            borderRadius: '9999px',
            backgroundColor: '#FFFFFF29',
            overflow: 'clip',
            position: 'relative',
        } },
        react_1.default.createElement(material_1.CircularProgress, { variant: "determinate", value: progress * 100, style: {
                color: progress > 0 ? '#FFC107' : '#00000000',
                position: 'absolute',
                top: 0,
                left: 0,
            }, sx: {
                [`& .${material_1.circularProgressClasses.circle}`]: {
                    strokeLinecap: 'round',
                },
            }, size: '100%', thickness: 3 }),
        react_1.default.createElement("button", { className: "w-[90%] h-[90%] top-[5%] left-[5%] absolute bg-[#0288D1] rounded-full", ...rest },
            react_1.default.createElement("div", { className: "flex items-center justify-center h-[34%]" }, progress === 0 ? (react_1.default.createElement(icons_material_1.PlayArrow, { sx: { width: '100%', height: '100%', color: '#FFFFFF' } })) : (react_1.default.createElement(icons_material_1.Pause, { sx: { width: '100%', height: '100%', color: '#FFFFFF' } }))))));
}
exports.PlayButton = PlayButton;
